// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__2wN1z","white_btn":"styles_white_btn__Sr5-o"};